import { gql } from '@apollo/client';

export const isUsernameAvailable = gql`
  query IsUsernameAvailable($username: String!) {
    isUsernameAvailable(username: $username)
  }
`;
